import http from './http';

const addViews = (website, year, view, month, body = {}) => {
  return http.put(`/website/${website}/addstatview/${view}/month/${month}/year/${year}`, body);
};

const takeViews = (website, year, view, month, body = {}) => {
  return http.put(`/website/${website}/minstatview/${view}/month/${month}/year/${year}`, body);
};

export default { addViews, takeViews };
export { addViews, takeViews };
